import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { CurrencyInputComponent } from './currency-input.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
	],
	declarations: [CurrencyInputComponent],
	exports: [CurrencyInputComponent],
})
export class CurrencyInputModule {}
